import {useQuery} from "@tanstack/react-query";
import {readContactPathSelectBoxApi} from "../../../../api/correspondent/contractApi";

const useReadContactPathSelectBox = () => {
    const {data} = useQuery({
        queryKey: ["readContactPathSelect"],
        queryFn: async () => await readContactPathSelectBoxApi(),
        // staleTime: 6000 * 10,
        select: (res) => res?.result,
    });

    return {data};
};

export default useReadContactPathSelectBox;
